import React from 'react'
import { useSelector } from 'react-redux'
import ListFilterArea from './list_filter_area'
import Lists from './lists'
import Stdpc from '../stdpc/Stdpc'
import Page from './page'
import SEO from "../../libs/seo"
import {useRouteMatch} from "react-router-dom"

const ListGroup = (props) => {
    const { domain, minishopInfo } = useSelector(state => state.initial)
    const currentCategory = useSelector(state => state.category.currentCategory)
    const isComputerCate = currentCategory?.cate?.[0]?.cate_id === '0000000102'  // 표준 피씨 컴퓨터 대분류에서만 노출
    const match = useRouteMatch()

    return (
        domain && (
            <>
                {props.cateName != null && (
                    <>
                        {domain === 'pc' && (
                            <>
                                {match.path === '/list/:categoryID' && (
                                    <SEO
                                        title={`${props.cateName} PC견적 : 행복쇼핑`}
                                        description={`${props.cateName} PC견적 : 최저가 보장 가격비교 사이트, 온라인 쇼핑몰 비교는 행복쇼핑`}
                                        ogTitle={`${props.cateName} PC견적 : 행복쇼핑`}
                                        ogSiteName={`${props.cateName} PC견적 : 행복쇼핑`}
                                    />
                                )}
                            </>
                        )}
                    </>
                )}
                <ListFilterArea />
                {domain !== 'minishop' ? <Lists /> : minishopInfo && <Lists />}
                {isComputerCate && <Stdpc />}
                <Page />
            </>
        )
    )
}

export default ListGroup



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/list_group.js